/**
 * @file メッセージ表示状態管理
 */
'use strict'

/**
 * @classname FormChangeMessageVisibilityControlView
 * @classdesc メッセージ表示状態管理
 */
export default class FormChangeMessageVisibilityControlView {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.message-visibility-control')
	 */
	constructor($e) {
		console.log('FormChangeMessageVisibilityControlView.constructor')
		this._$e = $e
		this._$inputMessage = $('.option_description')
		this._$inputMessageGroup = this._$inputMessage.closest('.form-group')
		$e.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	onClick() {
		console.log('FormChangeMessageVisibilityControlView.onClick')
		if (this._$e.hasClass('no-message')) {
			this._$inputMessageGroup.slideUp()
			this._$inputMessage.addClass('ignore-validate').val('').removeClass('is-invalid').closest('.form-group').find('.error-tip').removeClass('show').find('.error-tip-inner').html('')
		} else {
			this._$inputMessageGroup.slideDown()
			this._$inputMessage.removeClass('ignore-validate')
		}
	}
}
